import axios from 'axios';
import handleError from 'services/handleError';

const getTaskList = async (toolPath, thunkAPI) => {
  let taskType = '';
  if (toolPath !== `/ai-fashion-store/order`) {
    taskType = '/task';
  }

  try {
    const { data } = await axios.get(`${toolPath}${taskType}/query`);

    return data;
  } catch (error) {
    if (!error.response) {
      return thunkAPI.rejectWithValue({
        message:
          'Network error. Please check your internet connection or try again later.',
        errorType: error.code || 'network_error',
        details: error.message,
      });
    }

    const status = error.response?.status;
    const data = error.response?.data;

    const errorDetails = await handleError(status, data);

    return thunkAPI.rejectWithValue(errorDetails);
  }
};

export default getTaskList;
